import { __assign } from "tslib";
// @ts-nocheck
import omit from 'lodash.omit';
import React from 'react';
import classNames from 'classnames';
import { Tag } from '@tencent/tea-component/lib/tag';
import { useDefaultValue } from '@tencent/tea-component/lib/form/controlled';
import { Row, Col } from '@tencent/tea-component/lib/grid';
import { Form } from '@tencent/tea-component/lib/form';
import { InputNumber } from '@tencent/tea-component/lib/inputnumber';
import { Bubble } from '@tencent/tea-component';
/**
 * 已废弃，请使用 BuyOptions2
 * @deprecated
 */
export function BuyOptions(props) {
    var _a = useDefaultValue(props, ''), value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, options = _a.options, _c = _a.optionsPerLine, optionsPerLine = _c === void 0 ? 4 : _c;
    return (React.createElement(Row, { gap: 8 }, options.map(function (option) { return (React.createElement(Col, { key: option.value, span: 24 / optionsPerLine },
        React.createElement(BuyOption, __assign({}, option, { active: option.value === value, onClick: function (event) { return onChange(option.value, { event: event }); } })))); })));
}
/**
 * 已废弃，请使用 BuyOptionsMultiple2
 * @deprecated
 */
export function BuyOptionsMultiple(props) {
    var _a = useDefaultValue(props, []), value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, options = _a.options, _c = _a.optionsPerLine, optionsPerLine = _c === void 0 ? 4 : _c;
    return (React.createElement(Row, { gap: 8 }, options.map(function (option) { return (React.createElement(Col, { key: option.value, span: 24 / optionsPerLine },
        React.createElement(BuyOption, __assign({}, option, { active: value === null || value === void 0 ? void 0 : value.includes(option.value), onClick: function (event) {
                if (typeof value === 'undefined')
                    return;
                var newValue = value.slice(0);
                if (newValue.includes(option.value)) {
                    newValue.splice(newValue.indexOf(option.value), 1);
                }
                else {
                    newValue.push(option.value);
                }
                onChange(newValue, { event: event });
            }, isBuyOptionsMultiple: true })))); })));
}
var MAP_TYPE_TO_TITLE = {
    CentOS: 'CentOS',
    CoreOS: 'Core OS',
    Debian: 'Debian',
    FreeBSD: 'FreeBSD',
    SUSE: 'SUSE',
    OpenSUSE: 'OpenSUSE',
    Ubuntu: 'Ubuntu Server',
    Windows: 'Windows Server',
    Tencent: 'Tencent',
    inputNumber: '',
};
/**
 * 已废弃，请使用 BuyOptionsOperatingSystem2
 * @deprecated
 */
export function BuyOptionsOperatingSystem(props) {
    var _a = useDefaultValue(props, ''), value = _a.value, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, options = _a.options, _c = _a.optionsPerLine, optionsPerLine = _c === void 0 ? 4 : _c;
    return (React.createElement(Row, { gap: 8, className: "buy-form-system" }, options.map(function (option) {
        var title = option.type ? MAP_TYPE_TO_TITLE[option.type] : '';
        return (React.createElement(Col, { key: option.value, span: 24 / optionsPerLine },
            React.createElement(BuyOption, __assign({}, option, { title: title, active: option.value === value, onClick: function (event) { return onChange(option.value, { event: event }); } }))));
    })));
}
/**
 * 已废弃，请使用 BuyOption2
 * @deprecated
 */
export function BuyOption(_a) {
    var title = _a.title, tag = _a.tag, segment = _a.segment, subtitle = _a.subtitle, info = _a.info, subinfo = _a.subinfo, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, type = _a.type, inputNumber = _a.inputNumber, inputNumberProps = _a.inputNumberProps, inputNumberBubble = _a.inputNumberBubble, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.isBuyOptionsMultiple, isBuyOptionsMultiple = _e === void 0 ? false : _e;
    var isInputNumber = type === 'inputNumber';
    var systemName = type === null || type === void 0 ? void 0 : type.toLowerCase();
    var renderOptionMultiVersion = function () { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "buy-option-multi-version" },
            React.createElement("div", { className: "buy-option-object" },
                React.createElement("div", { className: "buy-option-title" },
                    React.createElement("span", null, title),
                    tag && (React.createElement(Tag, { dark: active, className: classNames('buy-option-title-tag', {
                            normal: !active,
                        }), theme: "warning" }, tag)),
                    segment && React.createElement("div", null, segment),
                    subtitle && React.createElement("p", { className: "buy-option-subtitle" }, subtitle))),
            React.createElement("div", { className: "buy-option-content" },
                React.createElement("div", { className: "buy-option-content-p" }, info),
                subinfo && React.createElement("div", { className: "buy-option-subinfo" }, subinfo))),
        inputNumber && React.createElement("div", { className: "buy-option-multi-stepper" }, inputNumber),
        !inputNumber && inputNumberProps && (React.createElement("div", { className: "buy-option-multi-stepper" },
            React.createElement(Form.Control, { status: inputNumberProps.status, showStatusIcon: false, message: inputNumberProps.message }, inputNumberBubble ? (React.createElement(Bubble, __assign({}, inputNumberBubble),
                React.createElement(InputNumber, __assign({}, omit(inputNumberProps, ['status', 'message']))))) : (React.createElement(InputNumber, __assign({}, omit(inputNumberProps, ['status', 'message']))))))),
        React.createElement("div", { className: "buy-option-multi-devider" },
            React.createElement("div", { className: "buy-option-multi-devider-triangle__down" }),
            React.createElement("div", { className: "buy-option-multi-devider-triangle__up" })))); };
    var renderOptionNormalVersion = function () { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "buy-option-object" },
            React.createElement("div", { className: "buy-option-title" },
                React.createElement("span", null, title),
                tag && (React.createElement(Tag, { dark: active, className: classNames('buy-option-title-tag', {
                        normal: !active,
                    }), theme: "warning" }, tag)),
                subtitle && React.createElement("p", { className: "buy-option-subtitle" }, subtitle))),
        React.createElement("div", { className: "buy-option-content" },
            React.createElement("div", { className: "buy-option-content-p" }, info),
            subinfo && React.createElement("div", { className: "buy-option-subinfo" }, subinfo)))); };
    var renderOption = function () { return (React.createElement("div", { className: classNames({
            'buy-option': !isInputNumber,
            'buy-option-active': isBuyOptionsMultiple && active,
            'buy-option-checked': !isBuyOptionsMultiple && active,
            'buy-option-disabled': disabled,
            'buy-option-multi': isInputNumber,
            'buy-option-multi-active': (inputNumberProps === null || inputNumberProps === void 0 ? void 0 : inputNumberProps.value) && inputNumberProps.value > 0,
        }), onClick: function (e) {
            if (!disabled) {
                onClick(e);
            }
        } },
        type && !isInputNumber && (React.createElement("img", { className: "buy-option-icon", src: "https://imgcache.qq.com/open_proj/proj_qcloud_v2/buy/src/styles/icons/" + systemName + ".png", alt: type })),
        isInputNumber ? renderOptionMultiVersion() : renderOptionNormalVersion())); };
    return isInputNumber ? React.createElement("div", { className: "buy-form-plan" }, renderOption()) : renderOption();
}
//# sourceMappingURL=BuyOptions.js.map